<template>
  <FlashMessage v-if="failed" state="error">{{
    $t("customFlows.flashMessages.deleteFlow.error")
  }}</FlashMessage>
  <Modal :active="active" @close="emits('close')">
    <template #header>
      {{ $t("customFlows.deleteConfirmation.title") }}
    </template>

    <template #body>
      {{ $t("customFlows.deleteConfirmation.message", title) }}
    </template>

    <template #footer>
      <div class="buttons">
        <button
          class="button secondary"
          ref="cancelButton"
          @click="emits('close')"
        >
          {{ $t("cancel") }}
        </button>
        <button
          class="button dangerous"
          :disabled="pending"
          @click="deleteFlow"
        >
          {{ $t("customFlows.deleteConfirmation.submit") }}
        </button>
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { Modal, FlashMessage } from "@/components";
import { useDeleteCustomFlowMutation } from "@/graphql/operations";

const props = defineProps({
  active: {
    type: Boolean,
    required: true,
  },
  flowId: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
});
const emits = defineEmits(["close", "success"]);

const pending = ref(false);
const failed = ref(false);
const cancelButton = ref<HTMLButtonElement>();
onMounted(() => cancelButton.value?.focus());
const { executeMutation: executeDelete } = useDeleteCustomFlowMutation();
const deleteFlow = async () => {
  if (pending.value) return;
  pending.value = true;
  failed.value = false;
  try {
    const result = await executeDelete({ id: props.flowId });
    if (result.error || !result.data?.deleteFlow?.deletedFlowNodeId) {
      failed.value = true;
      return;
    }
    emits("success");
  } catch {
    failed.value = true;
  } finally {
    pending.value = false;
  }
};
</script>

<style scoped></style>
